import { Form, Input } from "antd";
import { useEffect, useState } from "react";
import { TipoDocumentoPersonaConstants } from "../../../types/typesConstants";
import { get_api_datospersona } from "../../../actions";
import { messageError, messageInfo } from "../../../helpers";
import dayjs from "dayjs";

export const PersonaDocumentoSearchInput = ({ tipodocumento, ...props }) => {
  const form = Form.useFormInstance();
  const [maxlength, setMaxlength] = useState(25);
  const { setFieldsValue } = form;
  const ChangeTipoDocumento = (tipodocumento) => {
    const itipodocumento = parseInt(tipodocumento);
    switch (itipodocumento) {
      case parseInt(TipoDocumentoPersonaConstants.Ruc):
        setMaxlength(11);
        break;
      case parseInt(TipoDocumentoPersonaConstants.Dni):
        setMaxlength(8);
        break;
      default:
        setMaxlength(25);
        break;
    }
  };
  useEffect(() => {
    ChangeTipoDocumento(tipodocumento);
  }, [tipodocumento]);

  const clearFieldsSearch = () => {
    setFieldsValue({
      persona: {
        nombrecompleto: null,
        nombres: null,
        apepaterno: null,
        apematerno: null,
      },
    });
  };
  // const onChangePersona = (e) => {
  //   setFieldValue("nrodocumento", e.target.value);
  // };
  const searchPersona = async (nrodocumento, e) => {
    e.preventDefault();
    try {
      await form.validateFields([
        ["persona", "tipodocumento"],
        ["persona", "nrodocumento"],
      ]);
      if (!!tipodocumento && !!nrodocumento) {
        const datosPersona = await get_api_datospersona({
          tipodocumento,
          nrodocumento,
        });
        if (datosPersona) {
          const itipodocumento = parseInt(tipodocumento);
          if (itipodocumento === TipoDocumentoPersonaConstants.Ruc) {
            setFieldsValue({
              persona: {
                ...datosPersona,
                nombres: null,
                apepaterno: null,
                apematerno: null,
                fechanacimiento: null,
              },
            });
          } else {
            setFieldsValue({
              persona: {
                ...datosPersona,
                fechanacimiento: dayjs(datosPersona?.fechanacimiento),
              },
            });
          }
        } else {
          clearFieldsSearch();
          messageInfo("No existe datos con el filtro ingresado");
        }
      } else messageInfo("Seleccione o ingrese el tipo y número de documento");
    } catch (error) {
      messageError(error);
    }
  };
  return (
    <Input.Search
      allowClear
      showCount
      maxLength={maxlength}
      enterButton
      onSearch={searchPersona}
      // onChange={onChangePersona}
      {...props}
    />
  );
};
